var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.39 35.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 { fill: #fff; }\n      .cls-2 { fill: #2365af; }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.39,17.69c0,9.77-7.92,17.69-17.69,17.69h0C7.92,35.39,0,27.46,0,17.69h0C0,7.92,7.92,0,17.69,0h0c9.77,0,17.69,7.92,17.69,17.69h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.43,
    cy: 10.68,
    r: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.53,
    y: 14.48,
    width: 3.8,
    height: 11.39,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.24,18.66v6.46c0,.42-.34.76-.76.76h-2.28c-.42,0-.76-.34-.76-.76v-5.32c0-1.05-.85-1.9-1.9-1.9s-1.9.85-1.9,1.9v5.32c0,.42-.34.76-.76.76h-2.28c-.42,0-.76-.34-.76-.76v-9.87c0-.42.34-.76.76-.76h2.28c.42,0,.76.34.76.76v.49c.76-.98,2.02-1.63,3.42-1.63,2.1,0,4.18,1.52,4.18,4.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2913270a879d78da8544752f29586b5a.svg";
export { ForwardRef as ReactComponent };